/** Current Host */
export const CURRENT_HOST = window.location.host;

/** Is Student */
export const isStudent = CURRENT_HOST === import.meta.env.VITE_STUDENT_URL;

/** Is Staff */
export const isStaff = CURRENT_HOST === import.meta.env.VITE_STAFF_URL;

/** Host Type */
export const hostType = isStudent ? "student" : isStaff ? "staff" : "";

/** 로그인 성공 후 리다이렉트 URL */
export function getLoginReturnUrl(): string {
  return window.location.origin + "/main";
}

/** 로그아웃 후 리다이렉트 URL */
export function getLogoutReturnUrl(): string {
  if (isStudent) return window.location.origin + "/";
  if (isStaff) return window.location.origin + "/login";
  return window.location.origin + "/";
}
